<div class="d-flex flex-column main-container dashboard-container management-dashboard h-100">
  <div class="main-profile">
    <div class="breadcrumb mb-0">
      <app-ng7-dynamic-breadcrumb [bgColor]="breadcrumbConfig['bgColor']" [fontSize]="breadcrumbConfig['fontSize']"
        [fontColor]="breadcrumbConfig['fontColor']" [lastLinkColor]="breadcrumbConfig['lastLinkColor']"
        [symbol]="breadcrumbConfig['symbol']"></app-ng7-dynamic-breadcrumb>
    </div>
  </div>

  <h1 class="main-title mb-3">Dashboard</h1>

  <div class="container-fluid dashboard">
    <div class="row g-4">
      <div class="col-xl-3 col-lg-6">
        <div class="card main-box">
          <div class="card-body hello-box">
            <div class="text-center">
              <h2 class="card-title">Hello, {{ userName }} !</h2>
              <p class="welcome-text">Welcome to Teksun Family! We are glad that you visited this dashboard.</p>
              <div class="primary-button">
                <button routerLink="/profile" mat-flat-button class="update-profile-btn">
                  <span class="create-button">Update Profile</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-xl-3 col-lg-6" *ngIf="userRole === 'Super Admin'">
        <div class="card dashboard-card">
          <div class="card-body d-flex align-items-center justify-content-between">
            <div>
              <h4 class="dashboard-card-heading">{{ this.countUser }}</h4>
              <p class="dashboard-card-paragraph">Total Users</p>
            </div>
            <div class="dashboard-card-img">
              <img src="./assets/images/team.png" alt="" class="w-100">
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-6" *ngIf="userRole === 'Super Admin'">
        <div class="card dashboard-card">
          <div class="card-body d-flex align-items-center justify-content-between">
            <div>
              <h4 class="dashboard-card-heading">{{countclient}}</h4>
              <p class="dashboard-card-paragraph">Total Clients</p>
            </div>
            <div class="dashboard-card-img">
              <img src="./assets/images/client.png" alt="" class="w-100">
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-6" *ngIf="userRole === 'Super Admin'">
        <div class="card dashboard-card">
          <div class="card-body d-flex align-items-center justify-content-between">
            <div>
              <h4 class="dashboard-card-heading">{{countProject}}</h4>
              <p class="dashboard-card-paragraph">Total Projects</p>
            </div>
            <div class="dashboard-card-img">
              <img src="./assets/images/document.png" alt="" class="w-100">
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-12" *ngIf="userRole === 'Super Admin'">
        <div class="card main-box">
          <h2 class="card-title ms-3 mt-3">Management Overview</h2>
          <div class="card-body">
            <div style="text-align:center">
              <apx-chart [series]="hBarChartOptions.series" [chart]="hBarChartOptions.chart"
                [dataLabels]="hBarChartOptions.dataLabels" [xaxis]="hBarChartOptions.xaxis"
                [plotOptions]="hBarChartOptions.plotOptions"></apx-chart>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-12" *ngIf="userRole === 'Super Admin'">
        <div class="card main-box">
          <div class="d-flex justify-content-between">
            <h2 class="card-title ms-3 mt-3">Candidate Status</h2>
            <form>
              <mat-form-field appearance="fill" class="form-option dashboard-select mx-2 mt-2 my-form-field">
                <mat-select placeholder="Select" [(value)]="job" (selectionChange)="getJobId(job)"
                  panelClass="dashboard-cs-dropdown">
                  <mat-option [value]="option" *ngFor="let option of list">{{ option.vName }}</mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </div>

          <div class="card-body">
            <div>
              <apx-chart [series]="donutChartOptions.series" [chart]="donutChartOptions.chart"
                [labels]="donutChartOptions.labels" [responsive]="donutChartOptions.responsive"
                [tooltip]="donutChartOptions.tooltip" [plotOptions]="donutChartOptions.plotOptions"
                [legend]="donutChartOptions.legend"></apx-chart>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-12" *ngIf="userRole === 'Super Admin'">
        <div class="card main-box">
          <h2 class="card-title ms-3 mt-3">Purchase Request Overview</h2>
          <div class="card-body py-3">
            <div style="text-align:center">
              <apx-chart [series]="barChartOptions.series" [chart]="barChartOptions.chart"
                [xaxis]="barChartOptions.xaxis" [plotOptions]="barChartOptions.plotOptions"></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- 
    <div class="card main-box">
        <h2 class="card-title ms-3 mt-3">Billability</h2>
        <div class="card-body py-3">
            <div style="text-align:center">
                <apx-chart [series]="hBarChartOptions.series" [chart]="hBarChartOptions.chart"
                    [plotOptions]="hBarChartOptions.plotOptions" [dataLabels]="hBarChartOptions.dataLabels"
                    [xaxis]="hBarChartOptions.xaxis" class="h-50"></apx-chart>
            </div>
        </div>
    </div>

    <div class="card account-card">
        <div class="card-header">
            <h2 class="card-title">Users List</h2>
            <div class="primary-button">
                <button routerLink="/management/users/create" mat-flat-button>
                    <mat-icon>add</mat-icon><span class="create-button"> Create User</span>
                </button>
            </div>
        </div>
        <div class="card-body">
            <div class="account-wrapper" *ngFor="let count of countData">
                <p class="account-listing">{{count.usercount}}</p>
                <p class="account-roles">{{count.vName}}</p>
            </div>
        </div>
    </div>
 -->